import { useState, useEffect } from 'react';

export const useChartLoading = (fetchFunction, dependencies = []) => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null,
    hasData: false
  });

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      setState(prev => ({ ...prev, loading: true, error: null }));
      
      try {
        const result = await fetchFunction();
        
        if (isMounted) {
          setState({
            data: result,
            loading: false,
            error: null,
            hasData: result && (Array.isArray(result) ? result.length > 0 : true)
          });
        }
      } catch (err) {
        if (isMounted) {
          setState({
            data: null,
            loading: false,
            error: err.message || 'Erreur de chargement',
            hasData: false
          });
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, dependencies);

  return state;
};